import apiClient from './apiClient';
import {NoticeType} from "../types/NoticeType";

const fetchFCMMessageAPI = async () : Promise<NoticeType[]> => {
	const response = await apiClient.get('/api/public/system/notice/list');
	return response.data;
}

const sendMessageAPI = async (data: any) : Promise<NoticeType[]> => {
	const response = await apiClient.post('/api/admin/common/message/fcm', {
		messages: data,
	});
	return response.data;
}

const fcmMessageAPI = {
	fetchFCMMessageAPI,
	sendMessageAPI,
}

export default fcmMessageAPI;

